import { createIcon } from '../createIcon';

export const PauseIconConfig = {
  name: 'PauseIcon',
  height: 512,
  width: 448,
  svgPath: 'M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const PauseIcon = createIcon(PauseIconConfig);

export default PauseIcon;